import React from 'react';
import {ReadPropsMyAsset} from '../../../../home/helper/request.props.js';
import {PresenterReadMyAsset} from '../../../../home/presenter.js'
import iconMaping from '../../../../utils/IconMaping.js';
import AssetRow from './AssetRow.js';
import lang from 'config/language' 
import PopoverHelper from 'utils/PopoverHelper';
// Modal 
import ModalReasign from '../Modal/ModalReasign.js';
import ModalMoveAsset from '../Modal/ModalMoveAsset.js';
import ModalDetailMyAsset from '../Modal/ModalDetailMyAsset.js';
import ModalRequestMaintenance from '../Modal/ModalRequestMaintenance.js';
import ModalExtend from '../Modal/ModalExtend.js';

//Utils
import {HandlingSometingWentWrong} from '../../../../utils/HandlingMessage.js'
/*import TimerConfig from '../../../../utils/TimerConfig.js';*/

// TOAST
/*import { toast } from 'react-toastify';*/

import FilterComponent from '../../../../asset/simple_asset/helper/component/FilterComponent.js';
import Pagination from '../../../../component/Pagination.js';
import classnames from 'classnames';
import windowStop from '../../../../utils/windowStop.js';

class AssetList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        summaryTab                  : 1,
        isLoading                   : true,        
        RawData                     : [],
        SelectedItem                : null,
        SelectedItems               : null,
        checkedItems                : {},
        modal                       : false,
        modalDetail                 : false,
        modalRequstMaintenance      : false,
        modalMoveAsset              : false,
        modalExtend                 : false,
        dataModalRequestMaintenance : '',
        dataModalExtend             : undefined,
        USER                        : null,
        SITE                        : null,
        LOCATION                    : null,
        dropdownOpen                : false,
        bulkChecked                 : false,
        activeToggle                : {activeIcon : null, activeField : 'Name'},
        // ***Pagination
        table_loading : false,
        current       : 0,
        count         : 0,
        limit         : 0,
    }

    this.tab           = ['asset', 'location', 'site', 'status', 'type', 'serial_number']
    this.params_filter = '';
    this.params_order  = '';
    this.params_page   = 1;

    this.generateRow = this.generateRow.bind(this);
    
    this.onReadSuccess = this.onReadSuccess.bind(this)
    this.onReadFailed = this.onReadFailed.bind(this)
    
    // Modal Detail
    this.toggleModalDetail           = this.toggleModalDetail.bind(this);
    this.closeModalDetail            = this.closeModalDetail.bind(this);
    
    // Generated Choosed Filter
    this.generateFilter              = this.generateFilter.bind(this);
    
    // Modal Request Maintenance 
    this.openModalRequstMaintenance  = this.openModalRequstMaintenance.bind(this)
    this.closeModalRequstMaintenance = this.closeModalRequstMaintenance.bind(this)
    
    this.toggleModalMoveAsset        = this.toggleModalMoveAsset.bind(this);
    this.closeModalMoveAsset         = this.closeModalMoveAsset.bind(this);
    this.openModalExtend             = this.openModalExtend.bind(this);
    this.closeModalExtend            = this.closeModalExtend.bind(this);
    this.hardReload                  = this.hardReload.bind(this);
    this.onItemsCheckChanged         = this.onItemsCheckChanged.bind(this);
    this.onCheckedBulk               = this.onCheckedBulk.bind(this);
    this.toggleDropdown              = this.toggleDropdown.bind(this);

    this.bulkReasign = this.bulkReasign.bind(this);
    this.bulkMode    = false

  }

  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    })
  }

  // ########################### FILTERING ########################### 
  dataWillFilter(filter){
    this.params_filter = filter;
    this.loadAsset(this.state.summaryTab, this.params_order, filter, 1)
  }

  /* ORDER DATA */
  dataWillOrder(order){
    let parameter_order = 'ordering=' + order;
    this.setState({activeToggle: {
      activeField : order,
      activeIcon  : iconMaping.AVICON_ASC   
    }})

    if(this.params_order === parameter_order){
      this.params_order = 'ordering=-' + order;
      this.setState({activeToggle: {
        activeField : order,
        activeIcon  : iconMaping.AVICON_DESC 
      }})

    } else {
      this.params_order = parameter_order;
      this.setState({activeToggle: {
        activeField : order,
        activeIcon  : iconMaping.AVICON_ASC
      }})
    }

    this.loadAsset(this.state.summaryTab, this.params_order, this.params_filter, this.params_page)
  }

  updateRow(data, cancel = false){
    const items = this.state.RawData;
    let {SelectedItem, checkedItems} = this.state

    for (let i = 0; i < items.length ; i++){
      if (items[i].Alias === data.Asset.Alias){
        if (data.Response === null){
          items[i].Confirmation = {
            Accessed: data.Accessed,
            Alias: data.Alias,
            Response: null,
            ResponseTime: null,
            ToUser: data.ToUser
          }
        } else {
          items[i].Confirmation = null;
        }
        break;
      }
    }

    let newState = {
      RawData      : items,
    }

    if(!this.bulkMode) {
      newState.modal = false
      newState.SelectedItem = SelectedItem
    } else {
      if (!cancel){
        newState.modal = false
      }
      newState.modal = this.state.modal
      delete SelectedItem[data.Asset.Alias]
      delete checkedItems[data.Asset.Alias]

      if (Object.keys(SelectedItem).length === 0) {
        newState.SelectedItem = null
        newState.checkedItems = {}
        newState.modal        = false
        newState.bulkChecked  = false
        this.bulkMode         = false
      } else {
        newState.SelectedItem = SelectedItem
        newState.checkedItems = checkedItems
      }
    }
    this.setState(newState)
  }

  updateRowAfterMove(data){
    const items = this.state.RawData;

    for (let i = 0; i < items.length; i++){
      if(items[i].Alias === data.Alias){
        items[i] = data;
        break;
      }
    }
    let newState = {
      SelectedItem : null,
      RawData      : items,
    };
    this.setState(newState);
  }


  onItemsCheckChanged(check, data) {
    let { checkedItems } = this.state

    if (check) {
      checkedItems[data.Alias] = data
    } else {
      delete checkedItems[data.Alias]
    }
    this.setState({
      checkedItems: checkedItems,
    })
  }

  onCheckedBulk() {
    let { RawData } = this.state
    let bulkChecked, tmp_checkedItems

    if (this.state.bulkChecked) {
      tmp_checkedItems = {}
      bulkChecked = false
    } else {
      tmp_checkedItems = {}
      bulkChecked = true
      for (let i = 0; i < RawData.length ; i++) {
        if(RawData[i].Confirmation === null/* && RawData[i].NextReservation === null*/) {
          tmp_checkedItems[RawData[i].Alias] = RawData[i]
        }
      }  
    }
    
    this.setState({
      checkedItems   : tmp_checkedItems,
      bulkChecked    : bulkChecked
    })

  }

  /***************** MODAL Component Section ******************/
  toggleModalDetail(e, data) {
    e.preventDefault();       
    this.setState({
      SelectedItems  : data,
      modalDetail    : true,
    })
  }

  closeModalDetail(){
    this.setState({
      modalDetail     : false,
    })  
  }

  toggleOpenModalReasign(data, change = false) {
    this.setState({
      SelectedItem : data,
      modal        : true
    });
  }

  toggleCloseModalReasign() {
    this.bulkMode = false
    this.setState({
      SelectedItem : null,
      modal        : false
    });
  }

  toggleModalMoveAsset(data) {
    this.setState({
      SelectedItem  : data,
      modalMoveAsset : true
    });
  }

  closeModalMoveAsset(){
    this.setState({
      modalMoveAsset : false
    });
  }

  openModalRequstMaintenance(data) {
    this.setState({
      modalRequstMaintenance: true,
      dataModalRequestMaintenance: data
    })
  }

  openModalExtend(data) {
    this.setState({
      modalExtend: true,
      dataModalExtend: data
    })
  }

  closeModalExtend() {
    this.setState({
      modalExtend: false,
      dataModalExtend: null
    }) 
  }

  closeModalRequstMaintenance() {
    this.setState({
      modalRequstMaintenance: false,
    })
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (
        <AssetRow 
          self                = {this} 
          onItemsCheckChanged = {this.onItemsCheckChanged} 
          RowData             = {val} 
          history             = {this.props.history} 
          key                 = {index}
          defaultChecked      = {this.state.checkedItems[val.Alias] !== undefined}
          bulkChecked         = {this.state.bulkChecked}
          UserReducer         = {this.props.UserReducer}
        />
      )
    })
    return element;
  }

  generateFilter(filter) {
    let asd = filter.map((val, index) => {
      return (
        <span className="badge badge-pill badge-success badge-filter-item" key={index}>{val}</span>
      );
    });
    return asd;
  }

  hardReload() {
    this.loadAsset(this.state.summaryTab);
  }

  loadAsset(summaryTab, order='', filter, page) {
    PresenterReadMyAsset(
      ReadPropsMyAsset(this, this.onReadSuccess, this.onReadFailed, summaryTab, order, filter, page)
    )
  }

  onReadSuccess(params, response) {
    this.setState({
      RawData         : response.data.results,
      isLoading       : false,
      //Pagination
      table_loading : false,
      current       : response.data.current,
      count         : response.data.count,
      limit         : response.data.limit,
    })
  }

  onReadFailed(params, response) {
    this.setState({
      table_loading: false
    })
    console.log('Read failed')
  }  

  bulkReasign() {
    this.toggleOpenModalReasign(this.state.checkedItems)
    this.bulkMode = true
  }

  RenderRow() {
    if(this.state.isLoading) {
      return (<tr><td className="table-loading-inside" colSpan="100%">Loading data . . .</td></tr>)
    } 
    else if(this.state.count === 0) {
      return (<tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>)
    } 
    else if (this.state.count > 0){
      return (this.generateRow(this.state.RawData))
    } 
    else {
      return(HandlingSometingWentWrong('table'))
    }
  }

  handlePageClick = (data) => {
    windowStop()
    let selected = data.selected + 1;
    this.params_page = selected
    
    this.setState({ table_loading: true})

    this.loadAsset(this.state.summaryTab, this.params_order, this.params_filter, this.params_page)
  };

  /*  ============ LifeCyle ============ */
  componentWillReceiveProps(nextProps){
    if(nextProps.SummaryTab !== this.state.summaryTab){
      this.setState({
        summaryTab      : nextProps.SummaryTab,
        isLoading       : true,
      })
      this.loadAsset(nextProps.SummaryTab, this.params_order, this.params_filter, 1)
    }else{
      return
    }
  }

  componentDidMount() {
    this.loadAsset(this.state.summaryTab, this.params_order, this.params_filter, this.params_page)
    this.props.onRef(this);
  }

  componentWillUnmount() {
    windowStop()
    this.props.onRef(undefined)
  }

  render() {
    const {isAdmin} = this.props
    const { 
      checkedItems,
      activeToggle,
      current,
      count,
      limit,
      table_loading,
    } = this.state

    const subTitle = () => {
      let str, clsName;
      switch (this.state.summaryTab){
        case 1 :
          return null;
        case 2 :
          str     = '- Due This Month';
          clsName = 'text-success'
          break;
        case 3 :
          str     = '- Due This Week';
          clsName = 'text-warning'
          break;
        case 4 :
          str     = '- Overdue';
          clsName = 'text-danger'
          break;
        default : 
          return null;
      }
      return (<span className={clsName} style={{cursor:'auto'}}>{str}</span>)
    }

    return (
      <div>
        <div className="row">
          <div className="col-sm-6 ">
            <h4 className="card-title mb-0">
              <span className={iconMaping.AVICON_DIAMOND}></span>&nbsp;
              {isAdmin ? 'Assets/ Tools ' : 'Assets/ Tools Assigned to me '}{subTitle()}
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default" title="Total Assets">
                Total:&nbsp;{this.state.count} Assets
              </div>
            </div>
          </div>
          <div className="col-sm-6 ">
            <FilterComponent 
              onSearch={(e) => {this.dataWillFilter(e)}} 
              self={this} 
              target={'idle'} 
              FBColumn={this.tab}
            />
          </div>
        </div>
          <div className="row">
            <div className="col-md-12 m-top-8">
              { Object.keys(checkedItems).length > 0 &&
                <button className="btn btn-primary" onClick={this.bulkReasign}>Bulk Reasign</button>
              }
            </div>
          </div>
        <table className={classnames("table table-responsive table-hover table-outline mb-0 m-top-15 over-x", {"loading" : table_loading})}>
          <thead className="thead-default">
            <tr>
              <th>
                <label className="container-checkbox" style={{'marginTop': '-16px'}}>
                  <input type="checkbox" onClick={()=>this.onCheckedBulk()} checked={this.state.bulkChecked}/>
                  <span className="checkmark"></span>
                </label>
              </th>
              <th onClick={()=>this.dataWillOrder('Name')} className="pointer">
                My Asset/Tool{activeToggle.activeField === 'Name' && <i className={activeToggle.activeIcon}></i>}
              </th>
              <th onClick={()=>this.dataWillOrder('Tracking__DueDate')} className="pointer">
                Due Date{activeToggle.activeField === 'Tracking__DueDate' && <i className={activeToggle.activeIcon}></i>}
              </th>
              <th onClick={()=>this.dataWillOrder('SerialNumber')} className="pointer">
                Serial Number{activeToggle.activeField === 'SerialNumber' && <i className={activeToggle.activeIcon}></i>}
              </th>
              <th onClick={()=>this.dataWillOrder('Site__Name')} className="pointer">
                Site{activeToggle.activeField === 'Site__Name' && <i className={activeToggle.activeIcon}></i>}
              </th>
              <th onClick={()=>this.dataWillOrder('Location__Name')} className="pointer">
                Location{activeToggle.activeField === 'Location__Name' && <i className={activeToggle.activeIcon}></i>}
              </th>
              <th><span>Type</span></th>
              <th>
                <span>Status</span>
                <PopoverHelper
                  id="status"
                  placement="bottom"
                  content={lang.my_assets.status}
                />
              </th>
              <th onClick={()=>this.dataWillOrder('Owner__User__username')} className="pointer">
                Assigned{activeToggle.activeField === 'Owner__User__username' && <i className={activeToggle.activeIcon}></i>}
              </th>
              <th className="text-center" onClick={()=>this.dataWillOrder('User__first_name')}>
                Maintenance{activeToggle.activeField === 'User__first_name' && <i className={activeToggle.activeIcon}></i>}
              </th>
            </tr>
          </thead>
          <tbody>
            {this.RenderRow()}
          </tbody>
        </table>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            <Pagination
              current  = {current}
              count    = {count}
              limit    = {limit}
              handle   = {this.handlePageClick}
              isLoading= {this.state.table_loading}
            />
          </div>
        </div>

        <ModalReasign 
          selectedItem        = {this.state.SelectedItem}
          modalState          = {this.state.modal}
          closeModal          = {this.toggleCloseModalReasign.bind(this)}
          userData            = {this.state.USER}
          onReassignSuccess   = {this.updateRow.bind(this)}
          isPerUser           = {false}
          UserReducer         = {this.props.UserReducer}
          bulkMode            = {this.bulkMode}
        />

        <ModalMoveAsset 
          siteMaster={this.state.SITE}
          locationMaster={this.state.LOCATION}
          isOpen={this.state.modalMoveAsset}
          closeModal={this.closeModalMoveAsset}  
          onMoveSuccess={this.updateRowAfterMove.bind(this)}
          SelectedItem = {this.state.SelectedItem}
          UserReducer={this.props.UserReducer} 
        />

        <ModalDetailMyAsset 
          ModalState      = {this.state.modalDetail}
          CloseModal      = {this.closeModalDetail}
          SelectedItems   = {this.state.SelectedItems}
          UserReducer     = {this.props.UserReducer}
        />

        <ModalRequestMaintenance 
          UserReducer={this.props.UserReducer}
          RowData={this.state.dataModalRequestMaintenance}
          modalStatus={this.state.modalRequstMaintenance}
          openModal={this.openModalRequstMaintenance} 
          closeModal={this.closeModalRequstMaintenance}
        />

        <ModalExtend 
          UserReducer = {this.props.UserReducer}
          isToggle    = {this.state.modalExtend}
          open        = {this.openModalExtend} 
          close       = {this.closeModalExtend} 
          data        = {this.state.dataModalExtend}
          onSuccess   = {this.updateRowAfterMove.bind(this)}
        />

      </div>
    );
  }
}
export default (AssetList)


// WEBPACK FOOTER //
// ./src/App/home/helper/component/MyAsset/AssetList.js